import React from 'react';
import I18n from 'utils/I18n';

import {
  ActivityAnalysisNormalSmall,
  ActivityRoutesNormalSmall,
  NavigationGroupNormalSmall,
  SportsRunTrailNormalSmall
} from '@strava/icons';

import styles from './index.scss';
import image from './assets/cancel.svg';

const I18nPrefix = 'templates.account.subscription_features';

const SubscriptionFeatures = () => {
  const icons = {
    routes: <ActivityRoutesNormalSmall />,
    analysis: <ActivityAnalysisNormalSmall />,
    trail: <SportsRunTrailNormalSmall />,
    leaderboard: <NavigationGroupNormalSmall />
  };

  const data = {
    blurbs: [
      {
        header: I18n.t(`${I18nPrefix}.routes_header`),
        icon: icons.routes,
        text: I18n.t(`${I18nPrefix}.routes_text`)
      },
      {
        header: I18n.t(`${I18nPrefix}.analysis_header`),
        icon: icons.analysis,
        text: I18n.t(`${I18nPrefix}.analysis_text`)
      },
      {
        header: I18n.t(`${I18nPrefix}.trail_header`),
        icon: icons.trail,
        text: I18n.t(`${I18nPrefix}.trail_text`),
        badge: I18n.t(`${I18nPrefix}.trail_badge`)
      },
      {
        header: I18n.t(`${I18nPrefix}.leaderboard_header`),
        icon: icons.leaderboard,
        text: I18n.t(`${I18nPrefix}.leaderboard_text`)
      }
    ],
    img_src: image
  };

  const renderBlurb = (blurb, group) => {
    const hasIcon = blurb.icon;
    const hasBadge = blurb.badge;
    return (
      <div className={styles.blurb} key={`${group}-${blurb.header}`}>
        <div className={styles.blurbIconContainer}>{hasIcon && blurb.icon}</div>
        <div className={styles.blurbContent}>
          <p className={`${styles.body} text-bold`}>
            <span>{blurb.header}</span>
            {hasBadge && (
              <span className={styles.badge}>{blurb.badge.toUpperCase()}</span>
            )}
          </p>
          <p className={styles.caption}>{blurb.text}</p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.featuresSection}>
      <div className={`${styles.row} ${styles.featuresContainer}`}>
        <div
          className={`col-xs-12 col-sm-6 ${styles.featureColumn}`}
          key="blurbs"
        >
          {data.blurbs.map((blurb) => renderBlurb(blurb, blurb.header))}
        </div>
        <div
          className={`col-xs-12 col-sm-6 ${styles.featureColumn}`}
          key="image"
        >
          <img alt="" className={styles.columnImage} src={data.img_src} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionFeatures;
